<template>

  <div class="switch" v-bind:class="switchBool === false ? 'switch-off' : 'switch-on'" v-on:click="toggle">
    <div class="block"></div><span>{{switchBool === false ? offText : onText }}</span>
  </div>

</template>

<script>

export default {
    props: ['toggleBool', 'toggleFunction', 'onText', 'offText'],

    data() {
      return {
        switchBool: this.toggleBool
      }
    },
    methods: {
      toggle() {
        this.switchBool = !this.switchBool;
        this.toggleFunction(this.switchBool);
      }
    },
    watch: {
      toggleBool(newVal, oldVal) {
        this.switchBool = newVal;
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .switch {
      float:right;
      cursor:pointer;
      border:1px solid #aaaaaa;
      border-radius:4px;
      height:26px;
      box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
      position:relative;
      transition: all ease-in-out 0.1s;
      span {
        width:50px;
        display:block;
        line-height:26px;
        text-align:center;
        float:left;
        color:#FFFFFF;
      }
      .block {
        border-radius:3px;
        height:100%;
        width:10px;
        background-image: linear-gradient(to right, #ffffff , #dddddd);
        transition: all ease-in-out 0.1s;
        position:absolute;
        top:0px;
      }
    }
    .switch-on {
      background:#5cb85c;
      border-color: #398439;
      .block {
        left:0px;
      }
      &:hover {
        background:#398439;
      }
    } 
    .switch-off {
      background:#c9302c;
      border-color: #ac2925;
      .block {
        left:100%;
        margin-left:-10px;
      }
      &:hover {
        background:#ac2925;
      }
    }

</style>



// WEBPACK FOOTER //
// BoolSwitch.vue?e3fd71da